import React, { useContext } from 'react';
import BarChart from 'components/@common/Charts/BarChart';
import { PrintViewContext } from '../../../../providers/PrintViewProvider';

interface EnrichmentActivityChartProps {
  hearItTypeItCompletedSeries: number[];
  myChoiceKeyboardingCompletedSeries: number[];
  labels: string[];
  onClick?: (index: number) => void;
}

const EnrichmentActivityChart: React.FC<EnrichmentActivityChartProps> = ({
  hearItTypeItCompletedSeries,
  myChoiceKeyboardingCompletedSeries,
  labels,
  onClick
}) => {
  const { fullChartWidth } = useContext(PrintViewContext);

  return (
    <BarChart
      height={250}
      width={fullChartWidth}
      onClick={onClick}
      series={[
        {
          name: 'My Choice Keyboarding',
          data: myChoiceKeyboardingCompletedSeries
        },
        {
          name: 'Hear It, Type It',
          data: hearItTypeItCompletedSeries
        }
      ]}
      options={{
        chart: {
          stacked: true
        },
        colors: ['#4AE2A7', '#A165B7'],
        yaxis: [
          {
            decimalsInFloat: 0,
            title: {
              offsetX: -2,
              text: 'Activities',
              style: {
                color: '#373D3F',
                fontSize: '12px',
                fontWeight: 700,
                fontFamily: 'futura-pt'
              }
            }
          }
        ],
        xaxis: {
          categories: labels,
          labels: {
            offsetY: -4,
            style: {
              colors: '#373D3F',
              fontSize: '10px',
              fontFamily: 'futura-pt'
            }
          },
          axisTicks: { show: false }
        },
        legend: {
          offsetY: 2,
          horizontalAlign: 'left'
        },
        dataLabels: { enabled: false }
      }}
    />
  );
};

export default React.memo(EnrichmentActivityChart);
